import { Create } from "react-admin";
import { LandingForm } from "./LandingForm";

export const LandingCreate = (props) => (
  <Create title="Criação de Landing" {...props}>
    <LandingForm {...props} />
  </Create>
);
